import { Configuration } from "../types/Configuration";
import api from "../utils/axios";

export const fetchZones = async () => {
	try {
		const response = await api.get("Zone/zones");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch zones.");
		}
	} catch (error) {
		console.error("An error occurred while fetching zones:", error);
	}
};

export const fetchUserCashRegister = async () => {
	try {
		const response = await api.get("UserCashRegister");
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch status.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};

export const getGoogleApiKey = async () => {
	try {
		const response = await api.get<Configuration>(
			"Configuration/google-api-key"
		);
		if (response.status === 200) {
			return response?.data;
		} else {
			console.error("Failed to fetch the api key.");
		}
	} catch (error) {
		console.error("An error occurred while fetching status:", error);
	}
};
